import HeaderController from './shop/header/Controller/headerController';

document.addEventListener('DOMContentLoaded', () => {
    new HeaderController();
});
